var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.877,62.249h-7.06v-8.718c0-1.104-0.896-2-2-2s-2,0.896-2,2v10.718c0,1.104,0.896,2,2,2h9.06c1.104,0,2-0.896,2-2 S35.981,62.249,34.877,62.249z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.877,29.751h-9.06c-1.104,0-2,0.896-2,2v10.717c0,1.104,0.896,2,2,2s2-0.896,2-2v-8.717h7.06c1.104,0,2-0.896,2-2 S35.981,29.751,34.877,29.751z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.183,29.751h-9.06c-1.104,0-2,0.896-2,2s0.896,2,2,2h7.06v8.717c0,1.104,0.896,2,2,2s2-0.896,2-2V31.751 C72.183,30.647,71.287,29.751,70.183,29.751z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.183,51.531c-1.104,0-2,0.896-2,2v8.718h-7.06c-1.104,0-2,0.896-2,2s0.896,2,2,2h9.06c1.104,0,2-0.896,2-2V53.531 C72.183,52.427,71.287,51.531,70.183,51.531z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.960b3c12177abf001127807b43befe6b.svg";
export { ForwardRef as ReactComponent };